import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { Sparte } from '@mwe/models';
import { NgbDropdown, NgbDropdownButtonItem, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { TranslateCategoryPipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-category-dropdown-filter',
  templateUrl: './category-dropdown-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    NgClass,
    TranslatePipe,
    TranslateCategoryPipe,
  ],
})
export class CategoryDropdownFilterComponent {
  categoryOptions = input<Sparte[]>([]);
  selectedCategory = model<Sparte>();
  onSelectedCategory = output<Sparte>();

  isFernwaermeTariffClass(sparte: Sparte): boolean {
    return ['HEIZUNG', 'WARMWASSER', 'HEIZUNG_WARMWASSER', 'KALT-/ABWASSER', 'KALT_ABWASSER'].includes(sparte);
  }

  selectCategory(category: Sparte): void {
    this.selectedCategory.set(category);
    this.onSelectedCategory.emit(this.selectedCategory());
  }
}
